import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import React from "react";
import { MenuOptionType } from "../../../../../controls";
import { AssetParameters } from "../../models/AssetParameters";

type Props = {
	setAssetNodeSelectedInTree: (node: any | null) => void;
	setAssetId: Function;
	setShowModal: (modal: "new" | "edit" | "delete" | "view" | "") => void;
	handleMoveUp: ({ assetId }: { assetId: number }) => void;
	handleMoveDown: ({ assetId }: { assetId: number }) => void;
};

export const useAssetOptionsFunctions = ({
	setAssetNodeSelectedInTree,
	setAssetId,
	setShowModal,
	handleMoveUp,
	handleMoveDown,
}: Props) => {
	const getMenuOptions = (data: AssetParameters) => {
		let options: MenuOptionType[] = [];
		options = options.concat([
			{
				name: "New Asset",
				key: "new_asset",
				onClick: () => {
					if (!data) {
						setAssetNodeSelectedInTree(null);
					}
					setShowModal("new");
				},
				icon: <PlaylistAddIcon />,
			},
		]);
		if (data) {
			options = options.concat([
				{
					name: "Edit Asset",
					key: "edit_asset",
					//disabled: !data.isEditable,
					onClick: () => {
						setAssetId(data.id);
						setShowModal("edit");
					},
					icon: <EditIcon />,
				},
				{
					name: "View Asset",
					key: "view_asset",
					onClick: () => {
						setAssetId(data.id);
						setShowModal("view");
					},
					icon: <FindInPageIcon />,
				},
			]);
			if (!data.droppable) {
				options = options.concat([
					{
						name: "Delete Asset",
						key: "delete_asset",
						//disabled: !data.isEditable,
						onClick: () => {
							setAssetId(data.id);
							setShowModal("delete");
						},
						icon: <DeleteIcon />,
					},
					// {
					//   name: "Move Up",
					//   key: "move_up_asset",
					//   disabled: data.isAtTop,
					//   onClick: () => {
					//     handleMoveUp({ assetId: data.id });
					//   },
					//   icon: <ArrowUpwardIcon />,
					// },
					// {
					//   name: "Move Down",
					//   key: "move_down_asset",
					//   disabled: data.isAtBottom,
					//   onClick: () => {
					//     handleMoveDown({ assetId: data.id });
					//   },
					//   icon: <ArrowDownwardIcon />,
					// },
				]);
			}
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
